var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-24", attrs: { id: "center-reason-setting" } },
    [
      _c("div", { staticClass: "py-10 flex justify-center" }, [
        _c(
          "div",
          {
            staticClass:
              "relative w-180 h-min py-5 bg-pure-white border border-slate-400 rounded-3xl",
            attrs: { id: "reason-card" }
          },
          [
            _c(
              "div",
              {
                staticClass: "py-5 px-10 space-y-4 border-b border-slate-400",
                attrs: { id: "reason-header" }
              },
              [
                _c(
                  "div",
                  { staticClass: "flex flex-col gap-2" },
                  [
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlTextTitle3", {
                          attrs: { text: "Cancellation & Rescheduling Reasons" }
                        }),
                        _vm._v(" "),
                        _c("BlBubbleCount", {
                          attrs: { count: _vm.totalCenterReasonSettings || 0 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "Create a list of cancellation and rescheduling reasons, with colors representing each reason in the Analytics."
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex items-center gap-4" },
                  [
                    _c("BlInputText", {
                      attrs: { input: _vm.nameInput },
                      on: { changed: _vm.inputHandler }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "relative" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "relative h-10 w-24 px-4 flex items-center justify-between bg-pure-white border rounded cursor-pointer",
                          class: [
                            _vm.colorOpened
                              ? "border-light-purple"
                              : "border-slate-500"
                          ],
                          attrs: { "data-id": "color-reason" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.colorOpened = !_vm.colorOpened
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "w-6 h-6 flex-shrink-0 rounded-full border border-slate-300",
                            style: { backgroundColor: _vm.colorInput.color }
                          }),
                          _vm._v(" "),
                          _c("BlIcon", {
                            staticClass:
                              "absolute right-4 w-5 h-5 transition-all duration-300",
                            style: {
                              rotate: _vm.colorOpened ? "180deg" : "0deg"
                            },
                            attrs: {
                              "data-id": "color-reason",
                              icon: "chevron-down"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.colorOpened
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "absolute right-0 w-48 mt-2 z-10 p-4 bg-pure-white rounded border border-grey-200 shadow-md",
                              attrs: { "data-id": "color-reason" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "grid grid-cols-5 flex-wrap gap-2",
                                  attrs: { "data-id": "color-reason" }
                                },
                                _vm._l(_vm.colorOptions, function(item) {
                                  return _c("button", {
                                    key: item.color,
                                    staticClass:
                                      "h-6 w-6 flex-shrink-0 rounded border outline-none",
                                    class: [
                                      _vm.colorInput.color === item.color
                                        ? "border-light-purple"
                                        : "border-transparent"
                                    ],
                                    style: { backgroundColor: item.color },
                                    attrs: { "data-id": "color-reason" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.colorInput = item
                                      }
                                    }
                                  })
                                }),
                                0
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("BlInputButton", {
                      attrs: {
                        icon: "plus",
                        label: "Create",
                        loading: _vm.submitLoading,
                        disabled: !_vm.nameInput.model
                      },
                      on: { clicked: _vm.onCreate }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "py-5 px-10 space-y-2",
                attrs: { id: "reasons-body" }
              },
              [
                _c(
                  "div",
                  { staticClass: "grid grid-cols-5" },
                  [
                    _c("BlSort", {
                      staticClass: "col-span-2",
                      attrs: {
                        options: _vm.sortOptions,
                        defaultValue: { primary: "date", secondary: "desc" }
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChangeSort($event)
                        }
                      },
                      model: {
                        value: _vm.sortInput,
                        callback: function($$v) {
                          _vm.sortInput = $$v
                        },
                        expression: "sortInput"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.pageLoading
                  ? _c(
                      "div",
                      { staticClass: "h-128 grid place-items-center" },
                      [_c("div", { staticClass: "blum-loader" })]
                    )
                  : !_vm.centerReasonSettings.length
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "h-128 flex flex-col items-center justify-center gap-6"
                      },
                      [
                        _c("BlIcon", { attrs: { icon: "tags-empty" } }),
                        _vm._v(" "),
                        _c("BlTextBody1", {
                          staticClass: "text-center",
                          attrs: {
                            text:
                              "Don't see any reasons yet? No problem! They'll start appearing as soon as you create a new reason."
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      _vm._l(_vm.centerReasonSettings, function(reason) {
                        return _c(
                          "div",
                          { key: reason.id },
                          [_c("Item", { attrs: { reason: reason } })],
                          1
                        )
                      }),
                      0
                    )
              ]
            ),
            _vm._v(" "),
            _vm.totalCenterReasonSettings > 25
              ? _c(
                  "div",
                  { staticClass: "py-5 px-10", attrs: { id: "tags-footer" } },
                  [
                    _c("BlInputPagination", {
                      attrs: {
                        page: _vm.page,
                        perPage: _vm.perPage,
                        total: _vm.totalCenterReasonSettings
                      },
                      on: {
                        changed: _vm.changePage,
                        "changed-per-page": _vm.changePerPage
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35680066", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35680066","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/CenterReasonSetting.vue
// module id = null
// module chunks = 